import styled, { css } from "styled-components";

const Wrapper = styled.svg(({ theme }) => css`
  align-self: center;

  .outline-circle {
    stroke: #E1E1E1;
    stroke-width: 10;
  }

  .progress-circle {
    stroke: ${theme.palette.main.secondary};
    stroke-width: 10;

    transition: stroke-dashoffset 0.8s cubic-bezier(0.76, 0, 0.24, 1);
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }

  .progress {
    font-size: 25px;
    font-weight: ${theme.fonts.headingWeight};
    fill: ${theme.palette.main.secondary};
    stroke-linecap: butt;
  }

  .label {
    font-size: 16px;
    fill: #000;
  }

  .progress, .label {
    text-anchor: middle;
  }

  .percent {
    font-size: 18px;
  }
`);

export default Wrapper;